// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2bMeP","signatureBlock":"Footer_signatureBlock__2AWbZ","signature":"Footer_signature__2CzyH"};